import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import {
  Container,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import Checkbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  getClinicFacilities,
  getClinicStocks,
  getServices,
} from "../../../redux/reducers/clinicSlice";
import {
  createPrescriptionWoLoader,
  createProcedure,
  deleteProcedureById,
  getProceduresByPetId,
  updatePrescriptionByIdWoLoader,
  updateProcedureDateAndRemarkById,
} from "../../../redux/reducers/petSlice";
import { AppColors } from "../../../util/AppColors";
import { getProcedureDetailsNew } from "../../../util/function";
import { tblGrayBack } from "../../../util/object";

const tblHdrs = [
  "procedureName",
  "category",
  "subCategory",
  "doneAt",
  "remarks",
  "status",
  "extraStatus",
];
const nameExpan = {
  procedureName: "Procedure Name",
  category: "Category",
  subCategory: "Sub Category",
  remarks: "Remarks",
  status: "Status",
  extraStatus: "",
  doneAt: "Date",
};
const initValues = {
  procedure: null,
  variant: null,
  date: new Date(),
  addToAppointment: false,
  remarks: "",
};

const delBtn = { color: AppColors.red, width: 20, height: 20 };
const edtBtn = { color: AppColors.appPrimary, width: 20, height: 20 };

const ReminderProcedure = ({ addVsble, setAddVsble }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { appointment } = location.state;
  const [modVsble, setModVsble] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [procedValues, setProcedValues] = useState(initValues);
  const [procedErrs, setProcedErrs] = useState({});
  const [delModVsble, setDelModVsble] = useState(false);
  const [page, setPage] = useState(1);
  const procedure = useSelector((state) => state?.pet?.procedure);
  const {
    services,
    clinicStocks,
    details: clinicDet,
    facilities,
  } = useSelector((state) => state?.clinic);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const itemSize = 10;
  const defaultUrl = `?page=1&itemSize=${itemSize}`;

  useEffect(() => {
    getProcedures();
    dispatch(getServices());
    dispatch(getClinicStocks());
    dispatch(getClinicFacilities());
  }, []);

  useEffect(() => {
    if (addVsble) setModVsble(addVsble);
  }, [addVsble]);

  const getProcedures = () => {
    dispatch(
      getProceduresByPetId({
        petId: appointment?.appoinment?.petId,
        url: defaultUrl,
      })
    );
  };

  const handleModClose = () => {
    setAddVsble(false);
    setModVsble(false);
    setSelectedItem(null);
    setProcedValues(initValues);
    setProcedErrs({});
  };

  const getVarinatList = (serId) => {
    if (!serId) return [];
    const reqList = services?.data
      ?.find((ser) => ser?.serviceId === serId)
      ?.serviceVariants?.map((vnt) => ({
        name: vnt?.variantName,
        variantId: vnt?.variantId,
        servicePrice: vnt?.servicePrice,
        value: vnt?.variantName,
        serviceCharge: vnt?.serviceCharge,
        variantNumber: vnt?.variantNumber,
        serviceId: serId,
      }));
    return reqList ?? [];
  };

  const onChange = (name, value) => {
    const reqObj = { ...procedValues, [name]: value };
    const errObj = { ...procedErrs };
    if (name === "procedure") {
      reqObj.procedure = value?.value;
      reqObj.serviceId = value?.serviceId;
      reqObj.category = value?.category;
      reqObj.subCategory = value?.subCategory;
      const vrnts = getVarinatList(value?.serviceId);
      reqObj.variant = vrnts?.[0]?.value;
      reqObj.variantId = vrnts?.[0]?.variantId;
      errObj.variant = "";
      errObj.procedure = "";
    }
    if (name === "variant") {
      reqObj.variant = value?.value;
      reqObj.variantId = value?.variantId;
      errObj.variant = "";
    }
    setProcedValues(reqObj);
    setProcedErrs(errObj);
  };

  const getServiceList = () => {
    return (
      services?.data
        ?.filter(
          (sl) => !["lab", "radiology"].includes(sl?.category?.toLowerCase())
        )
        //  "diagnostics"
        ?.map((ser) => ({
          name: ser?.serviceName,
          value: ser?.serviceName,
          serviceId: ser?.serviceId,
          category: ser?.category,
          subCategory: ser?.subCategory,
          remarks: ser?.description,
        }))
    );
  };

  const handleDelete = (itm) => {
    setSelectedItem(itm);
    setDelModVsble(true);
  };

  const isValuesValid = () => {
    let errs = {};
    if (procedValues?.procedure?.length === 0 || !procedValues?.serviceId) {
      errs.procedure = "This field is required";
    }
    if (procedValues?.variant?.length === 0 || !procedValues?.variantId) {
      errs.variant = "This field is required";
    }
    setProcedErrs(errs);
    return Object.keys(errs)?.length > 0;
  };

  const handleSuccess = () => {
    getProcedures();
    setPage(1);
    handleModClose();
  };

  const handleSaveUpdate = async () => {
    if (isValuesValid()) return;
    // const data = {
    //   doneAt: moment(new Date(procedValues?.date)).format("YYYY-MM-DD"),
    //   remarks: procedValues?.remarks,
    //   procedureDetails: [],
    //   serviceType: procedValues?.variant,
    //   isFromPreventive: false,
    //   procedureVariantId: procedValues?.variantId,
    // };
    const resServ = services?.data?.find(
      (ser) => ser?.serviceId === procedValues?.serviceId
    );
    const reqVar = resServ?.serviceVariants?.find(
      (vnt) => vnt?.variantName === procedValues?.variant
    );
    let tax = 0;
    let total = reqVar?.serviceCharge ?? 0;
    if (resServ?.taxApplicability?.toLowerCase() === "yes") {
      tax +=
        resServ?.taxApplicability?.toLowerCase() === "yes"
          ? (Number(reqVar?.serviceCharge ?? 0) / 100) *
          Number(resServ?.tax ?? 0)
          : 0;
      total += tax;
    }
    const data = {
      procedureName: procedValues?.procedure ?? resServ?.serviceName,
      serviceId: procedValues?.serviceId ?? resServ?.serviceId,
      category: resServ?.category,
      subCategory: resServ?.subCategory,
      remarks: procedValues?.remarks,
      doneAt: moment(new Date(procedValues?.date)).format("YYYY-MM-DD"),
      status: "Pending",
      petId: appointment?.appoinment?.petId,
      serviceCharge: reqVar?.serviceCharge,
      serviceType: reqVar?.variantName,
      procedureDetails: [],
      tax,
      total,
      mrpPrice: Number(reqVar?.serviceCharge ?? 0),
      procedureVariantId: reqVar?.variantId,
      quantity: 1,
      isFromPreventive: false,
    };
    if (procedValues?.addToAppointment) {
      data.appointmentId = appointment?.appoinment?.appointmentId;
      const procedureDetailsResult = await getProcedureDetailsNew({
        servId: procedValues?.serviceId,
        varntId: procedValues?.variantId,
        services: services?.data ?? [],
        clinicStocks: clinicStocks?.data ?? [],
        pharmacyTaxId: clinicDet?.pharmacyTaxId,
        status: true,
        facilities,
        facilityId: reqDet?.appointment?.facilityId,
      });
      data.procedureDetails = procedureDetailsResult?.procedureDetails;
      if (procedureDetailsResult?.prescriptions?.length > 0) {
        const data = {
          status: "Pending",
          remark: "",
          prescription: procedureDetailsResult?.prescriptions,
          issue: "",
        };
        if (reqDet?.prescription?.[0]?.prescriptionId) {
          dispatch(
            updatePrescriptionByIdWoLoader({
              prescriptionId: reqDet?.prescription?.[0]?.prescriptionId,
              data,
            })
          );
        } else {
          dispatch(
            createPrescriptionWoLoader({
              appointmentId: reqDet?.appointment?.appointmentId,
              data,
            })
          );
        }
      }
    }
    if (selectedItem) {
      if (procedValues?.addToAppointment) {
        dispatch(deleteProcedureById(selectedItem?.procedureId)).then((res) => {
          if (res?.payload) {
            dispatch(
              createProcedure({
                data,
                successMessage: "Procedure added successfully",
              })
            ).then((res2) => {
              if (res2?.payload) handleSuccess();
            });
          }
        });

        // dispatch(
        //   updateProcedureById({ id: selectedItem?.procedureId, data })
        // ).then((res) => {
        //   if (res?.payload) handleSuccess();
        // });
      } else {
        dispatch(
          updateProcedureDateAndRemarkById({
            id: selectedItem?.procedureId,
            data: {
              doneAt: moment(new Date(procedValues?.date)).format("YYYY-MM-DD"),
              remarks: procedValues?.remarks,
            },
          })
        ).then((res) => {
          if (res?.payload) handleSuccess();
        });
      }
    } else {
      dispatch(
        createProcedure({ data, successMessage: "Reminder added successfully" })
      ).then((res) => {
        if (res?.payload) handleSuccess();
      });
    }
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedItem(null);
  };

  const onConfirmDelete = () => {
    if (!selectedItem?.procedureId) return;
    dispatch(deleteProcedureById(selectedItem?.procedureId)).then((res) => {
      if (res?.payload) {
        getProcedures();
        setPage(1);
        onCloseDelMod();
      }
    });
  };

  const handleChangePage = (e, selectedPage) => {
    dispatch(
      getProceduresByPetId({
        petId: appointment?.appoinment?.petId,
        url: `?page=${selectedPage}&itemSize=${itemSize}`,
      })
    );
    setPage(selectedPage);
  };

  const getCost = (serId = null) => {
    if (!serId) return 0;
    let total = 0;
    const reqSer = services?.data?.find((ser) => ser?.serviceId === serId);
    if (reqSer) total = reqSer?.serviceVariants?.[0]?.servicePrice;
    return total;
  };

  const handleEdit = (det) => {
    const reqObj = {
      ...procedValues,
      serviceId: det?.serviceId,
      procedure: det?.procedureName,
      date: new Date(det?.doneAt),
      remarks: det?.remarks,
    };
    const vrnts = getVarinatList(det?.serviceId)?.find(
      (li) =>
        li?.variantId === det?.procedureVariantId ||
        li?.name === det?.serviceType
    );
    if (vrnts) {
      reqObj.variant = vrnts?.value ?? det?.serviceType;
      reqObj.variantId = vrnts?.variantId ?? det?.procedureVariantId;
    }
    setProcedValues(reqObj);
    setSelectedItem(det);
    setModVsble(true);
  };

  const getProcedureList = () => {
    return procedure?.data?.filter(
      (li) => !li?.appointmentId && !li?.isFromPreventive
    );
  };

  return (
    <>
      <Container maxWidth="xl">
        <div className="back-white">
          <TableContainer sx={{ maxHeight: 400 }} className="mv20">
            <Table
              sx={{ minWidth: 200 }}
              aria-labelledby="tableTitle"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  {tblHdrs?.map((hdr, i) => (
                    <TableCell
                      style={tblGrayBack}
                      className="table-header-text"
                      key={hdr + i}
                    >
                      {nameExpan?.[hdr]}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {getProcedureList()?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={12} className="text-align-center h100">
                    <div className="no-rec">No records available</div>
                  </TableCell>
                </TableRow>
              )}
              <TableBody>
                {getProcedureList()?.map((li, ind) => {
                  return (
                    <TableRow>
                      {tblHdrs?.map((hdr, i) => {
                        return (
                          <TableCell key={`${ind} + ${i} + tr`} component="th">
                            <div>
                              {hdr === "procedureName" ? (
                                <div>
                                  <Custom3dotString
                                    str={li?.[hdr]}
                                    className="blue-color txt-semi-bold fs14 cursor"
                                    length={12}
                                  />
                                </div>
                              ) : hdr === "status" ? (
                                <div>
                                  <Typography
                                    className={`ph10 pv5 br5 flex-center font-medium fs14 ${new Date(li?.doneAt) >
                                      new Date(new Date().setHours(0, 0, 0, 0))
                                      ? "orange-back red-color"
                                      : "overdue"
                                      }`}
                                  >
                                    {new Date(li?.doneAt) >
                                      new Date(new Date().setHours(0, 0, 0, 0))
                                      ? "Pending"
                                      : "Overdue"}
                                  </Typography>
                                </div>
                              ) : hdr === "extraStatus" ? (
                                <div className="flex1-end">
                                  <div
                                    className="cursor"
                                    onClick={() => handleEdit(li)}
                                  >
                                    <div className="flex-center">
                                      <EditIcon sx={edtBtn} />
                                    </div>
                                    <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                      Edit
                                    </Typography>
                                  </div>
                                  <div
                                    className="cursor ml15"
                                    onClick={() => handleDelete(li)}
                                  >
                                    <div className="flex-center">
                                      <DeleteOutlineIcon sx={delBtn} />
                                    </div>
                                    <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                      Delete
                                    </Typography>
                                  </div>
                                </div>
                              ) : hdr === "doneAt" ? (
                                moment(new Date(li?.[hdr])).format(
                                  "DD MMM YYYY"
                                )
                              ) : (
                                li?.[hdr]
                              )}
                            </div>
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
              {Math.ceil(procedure?.totalRecords / itemSize) > 1 ? (
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div className="flex-end">
                        <Pagination
                          count={Math.ceil(procedure?.totalRecords / itemSize)}
                          variant="outlined"
                          color="primary"
                          page={page}
                          onChange={handleChangePage}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              ) : null}
            </Table>
          </TableContainer>
        </div>
      </Container>
      <CustomModal
        open={modVsble}
        onClose={handleModClose}
        header={selectedItem ? "Update" : "Add"}
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20 mt10">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="red-back4 br5 ph20 pv10 flex-row-between-align-center">
                <Typography className="red14 fs14 txt-semi-bold">
                  Cost
                </Typography>
                <Typography className="red14 fs14 txt-semi-bold">
                  Rs. {getCost(procedValues?.serviceId)}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">
                Procedure Name <span className="red-color">*</span>
              </Typography>
              <CustomSelect
                list={getServiceList()}
                value={procedValues?.procedure?.value ?? procedValues?.procedure}
                name="procedure"
                label=""
                newSelect
                handleChange={(e) => onChange("procedure", e)}
                error={!!procedErrs?.procedure}
                helperText={procedErrs?.procedure}
                disabled={selectedItem}
              // mandatoryField
              />
              {/* <CustomSelect
                list={getServiceList()}
                value={procedValues?.procedure}
                handleChange={(value) => onChange("procedure", value)}
                error={!!procedErrs?.procedure}
                helperText={procedErrs?.procedure}
                addNewSelect
                searchOnly
                disabled={selectedItem}
              /> */}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">
                Variant <span className="red-color">*</span>
              </Typography>
              <CustomSelect
                list={getVarinatList(procedValues?.serviceId)}
                value={procedValues?.variant?.value ?? procedValues?.variant}
                name="variant"
                label=""
                newSelect
                handleChange={(e) => onChange("variant", e)}
                error={!!procedErrs?.variant}
                helperText={procedErrs?.variant}
                disabled={selectedItem}
              // mandatoryField
              />
              {/* <CustomSelect
                list={getVarinatList(procedValues?.serviceId)}
                value={procedValues?.variant}
                handleChange={(value) => onChange("variant", value)}
                error={!!procedErrs?.variant}
                helperText={procedErrs?.variant}
                addNewSelect
                searchOnly
                disabled={selectedItem}
              /> */}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                label="Date"
                labelTop
                fullWidth
                handleChange={(e) => onChange("date", e?.target?.value)}
                value={procedValues?.date}
                mobileDate
                mandatoryField
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Checkbox
                label="Add To Appointment"
                checked={procedValues?.addToAppointment}
                onChange={() =>
                  onChange("addToAppointment", !procedValues?.addToAppointment)
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-medium fs14">Remarks</Typography>
              <CustomTextField
                fullWidth
                handleChange={(e) => onChange("remarks", e?.target?.value)}
                value={procedValues?.remarks}
                multiline
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-end">
                <div>
                  <CustomButton
                    text="Save"
                    smallBtn
                    onClick={handleSaveUpdate}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the procedure?
        </Typography>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-center mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                smallBtn
                onClick={onConfirmDelete}
              />
            </div>
            <div className="ml10">
              <CustomButton
                text="No"
                onClick={() => setDelModVsble(false)}
                smallBtn
              />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default ReminderProcedure;
